import { Component, OnInit } from "@angular/core";
import { TabService } from "./tabservice";
import { Tab } from "./tabmodel";




import { AuthService } from 'app/auth-guard/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { FccpResetpassword } from 'app/routes/sessions/FCCP/Fccp-component/resetpassword/fccp-resetpassword';
@Component({
selector: "tabsmenu",
templateUrl: "./tabsmenu.html",
})
export class Tabsmenu implements OnInit {
tabs = new Array<Tab>();
selectedTab: number;
constructor(private tabService: TabService,public authserice:AuthService,public dialog: MatDialog) {
    if(this.authserice.getstoragedtl().reset_flg == 'Y')
    {
        const dialogRef = this.dialog.open(FccpResetpassword,{
            width: '400px',
            hasBackdrop:false,
         
           
          });
    }
}
ngOnInit() {
this.tabService.tabSub.subscribe(tabs => {
this.tabs = tabs;
this.selectedTab = tabs.findIndex(tab => tab.active);
});}
tabChanged(event) {
console.log("tab changed");
}

removeTab(index: number): void {
this.tabService.removeTab(index);
}
}